import React from 'react'
import NavbarComponent from '../component/NavbarComponent'

const SchoolManagementCommittee = () => {
  return (
    <React.Fragment>
        <NavbarComponent />
        <div className="lg:p-10  pl-3 pr-3 pb-3">
          <div className="relative w-full overflow-x-auto shadow-md sm:rounded-lg">
            
            <table className="min-w-full border text-center">
              <thead className="border-b">
                <tr><td  colSpan={4}><div className="text-2xl w-full text-center  text-white py-3 bg-[#335377] font-semibold">
              School Management Committee
            </div></td></tr>
                <tr className="bg-gray-100">
                  <th className="py-3 text-lg"> S.No.</th>
                  <th className="py-3 text-lg"> Member Name</th>
                  <th className="py-3 text-lg">Designation</th>
                  <th className="py-3 text-lg">Phone No.</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    01
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Smt. Meenam Mishra
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    ( G.M Education )
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    8986872366
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    02
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Mr. Rajul Harkarni
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   G.M. Electrical
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  8986871488
                  </td>
                </tr>
                <tr className="border-b">
                <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    03
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Mrs. P.M. Nair
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Asst. Manager Education
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  8986875746
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    04
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Mr. S S Yadav
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Principal
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  8986875341
                  </td>
                </tr>
                <tr className="border-b">
                <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    05
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Mrs. Seema Prasad
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  PGT
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  8935933400
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    06
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Mr. S.R. Chattarjee
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   PGT
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  9470121192
                  </td>
                </tr>
                <tr className="border-b">
                <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    07
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Mr. Jagdish Prasad
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  PGT
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                 9523022464
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    08
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Mr. Ram Sagar Yadav
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Parent 
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  8709844882
                  </td>
                </tr>
                <tr className="border-b">
                <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    09
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Mr. Kuwar Singh
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  Parent
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  9631066321
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    10
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Mr. Biru Yadav
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  Parent
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  9934356224
                  </td>
                </tr>
                <tr className="border-b ">
                <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    11
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Mr. Lalit Mohan Bist 
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  Principal K.V. 1
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                  9404934686
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    12
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   Mrs. Gunjita Sinha
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                   TGT
                  </td>
                  <td className="lg:py-3 py-1 px-8 text-md font-medium text-gray-900 border-r">
                    8651037816
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <footer className="border-t-2">
     <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span
            className="text-black text-lg font-bold hover:text-blue-300 "
          
          >
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
     </footer>
    </React.Fragment>
  )
}

export default SchoolManagementCommittee